import { faSpinner } from "@fortawesome/pro-solid-svg-icons/faSpinner";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from "react";

interface IProps {
    component?: React.ElementType;
}

export const MprcSpinnerIndicator = ({ component: Component = "div" }: IProps) => (
    <Component>
        <FontAwesomeIcon fixedWidth spin icon={faSpinner} />
    </Component>
);
